import { getBasketPreiew } from '@/shared/api/other';

// Изменения вне реакта
export const BasketPreiewAction = async (): Promise<void> => {
  const cart = document.querySelector('.header-wrapper li.cart');

  const html = await getBasketPreiew();
  if (cart) cart.innerHTML = html;
};
